import React, {PropTypes} from 'react';
import { DateTime } from 'src_common/utils/time/time';
import { money } from '../../../../utils/format';
import { flatten } from 'flat';

class AuditDetailsLimits extends React.Component {

    normalizeData = (data) => {
        const { dailyLimit, monthlyLimit, weeklyLimit } = data;
        const normalize = {
            daily: {
                name: 'Daily limit',
                startsAt: dailyLimit ? dailyLimit.startAt : null,
                endAt: dailyLimit ? dailyLimit.endAt : null,
                limit: dailyLimit ? dailyLimit.amount : null,
                playable: dailyLimit ? dailyLimit.playableAmount : null,

            },
            weekly: {
                name: 'Weekly limit',
                startsAt: weeklyLimit ? weeklyLimit.startAt : null,
                endAt: weeklyLimit ? weeklyLimit.endAt : null,
                limit: weeklyLimit ? weeklyLimit.amount : null,
                playable: weeklyLimit ? weeklyLimit.playableAmount : null,

            },
            monthly: {
                name: 'Monthly limit',
                startsAt: monthlyLimit ? monthlyLimit.startAt : null,
                endAt: monthlyLimit ? monthlyLimit.endAt : null,
                limit: monthlyLimit ? monthlyLimit.amount : null,
                playable: monthlyLimit ? monthlyLimit.playableAmount : null,

            },

        }
        return normalize
    }

    renderEventDetailsTableRow(audits, toExclude, levelKey = [], styleClassNeme = 'none') {
        let keyArr = [...levelKey];
        let keysToConvert = [
            'balanceDelta',
            'balance',
            'withdrawableBalance',
            'operatorBalance',
            'totalAmount',
            'fundsLocked',
            'amount',
            'playableBalance',
            'payout',
            'operatorPayout',
            'totalStake',
            'stakePerLine',
            'operatorStakePerLine',
            'operatorTotalStake',
            'maxBet',
            'potentialReturns',
            'profit',
            'operatorProfit',
            'playableAmount'
        ];

        return Object.keys(audits).map((key) => {
            if (toExclude.includes(key) === false) {

                if (audits[key] !== null && audits[key].constructor === Object) {
                    keyArr.push(key);
                    return this.renderEventDetailsTableRow(audits[key], toExclude, keyArr, styleClassNeme)
                }

                if (audits[key] !== null && audits[key].constructor === Array) {
                    if(audits[key][0] && audits[key][0].constructor === Object) {
                        let flattenData = flatten(audits[key]);
                        return Object.keys(flattenData).map(x => {
                            let lastKey = x.split('.').pop();
                            return (
                                <tr className={styleClassNeme}>
                                    <td>{key.charAt(0).toUpperCase() + key.slice(1) + '.' + x}</td>
                                    <td>{ keysToConvert.includes(lastKey) ? money(flattenData[x]) : String(flattenData[x]) }</td>
                                </tr>
                            )
                        })
                    } else {
                        return (
                            <tr className={styleClassNeme}>
                                <td>{key.charAt(0).toUpperCase() + key.slice(1)}</td>
                                <td>{audits[key].map((audit, keyArr) => JSON.stringify(audit).replace(/"/g, " ") + ( keyArr != audits[key].length-1 ? ', ' : '' )) }</td>
                            </tr>
                        )
                    }
                }

                audits[key] = keysToConvert.includes(key) ? money(audits[key]) : audits[key];

                let renderKey = keyArr.join('.');
                return (
                    <tr className={styleClassNeme} key={key}>
                        { keyArr.length > 0 ?
                            <td>{ renderKey.charAt(0).toUpperCase() + renderKey.slice(1) + '.' + key }</td> :
                            <td>{ key.charAt(0).toUpperCase() + key.slice(1) }</td> }
                        <td>{ (typeof(audits[key]) === 'string' || audits[key] === null) ? audits[key] : JSON.stringify(audits[key]) }</td>
                    </tr>
                )
            }
        })
    }

    renderEventDetailsTable() {
        const {audits, id} = this.props;
        let toExclude = ['body'];

        let eventType = id.split('_');
        let eventArr = eventType[eventType.length - 1].split('-');
        for (let i = 0; i < toExclude.length; i++) {
            if (eventArr[0].includes(toExclude[i].slice(0, 5))) {
                toExclude.splice(i, 1);
            }
        }

        const data = this.normalizeData(audits.body);

        return (
            <table>
                <thead>
                <tr>
                    <td>
                        <strong>
                            {eventArr[0].charAt(0).toUpperCase() + eventArr[0].slice(1) + ' ' + eventArr[1].charAt(0).toUpperCase() + eventArr[1].slice(1) }
                        </strong>
                    </td>
                    <td>
                        <strong>
                            Value
                        </strong>
                    </td>
                </tr>
                </thead>
                <tbody>
                {Object.values(data).map(elem => {
                    return (
                        <React.Fragment key={elem.name}>
                            <tr>
                                <td><b>{elem.name}</b></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Starts at:</td>
                                <td>{elem.startsAt !== null ? (DateTime.from(elem.startsAt)?.format("MMM Do YYYY") ?? '--') : '--'}</td>
                            </tr>
                            <tr>
                                <td>Ends at:</td>
                                <td>{elem.endAt !== null ? (DateTime.from(elem.endAt)?.format("MMM Do YYYY") ?? '--') : '--'}</td>
                            </tr>
                            <tr>
                                <td>Limit amount:</td>
                                <td>{elem.limit !== null ? money(elem.limit, audits.body.currency || 'EUR') : '--'}</td>
                            </tr>
                            <tr>
                                <td>Playable:</td>
                                <td>{elem.playable !== null ? money(elem.playable, audits.body.currency || 'EUR') : '--'}</td>
                            </tr>
                            <br/>
                        </React.Fragment>
                    )
                })}
                </tbody>
            </table>
        )
    }

    render() {
        return (
            <div className="audit-details-bets">
                { this.renderEventDetailsTable() }
            </div>
        );
    }
}

export default AuditDetailsLimits;
